import React from 'react';
import { ProgressBar } from 'primereact/progressbar';
import { Tag } from 'primereact/tag';

const METRICS = [
    { key: 'planned', label: 'Planificadas', icon: 'pi pi-calendar' },
    { key: 'completed', label: 'Completadas', icon: 'pi pi-check-circle' },
    { key: 'notCompleted', label: 'No completadas', icon: 'pi pi-times-circle' },
    { key: 'unplanned', label: 'Inesperadas', icon: 'pi pi-bolt' },
    { key: 'cancelled', label: 'Canceladas', icon: 'pi pi-ban' },
    { key: 'pendingReports', label: 'Reportes pendientes', icon: 'pi pi-file-edit' },
    { key: 'officeActivities', label: 'Bloques de oficina', icon: 'pi pi-briefcase' }
];

const agendaStatus = (agenda) => {
    if (!agenda) return { label: 'Sin agenda', severity: 'secondary' };
    if (agenda.reviewStatus === 'reviewed') return { label: 'Revisada', severity: 'success' };
    if (agenda.reviewStatus === 'returned') return { label: 'Devuelta', severity: 'danger' };
    if (agenda.status === 'submitted') return { label: 'Enviada', severity: 'info' };
    if (agenda.status === 'draft') return { label: 'Borrador', severity: 'warning' };
    return { label: 'No enviada', severity: 'danger' };
};

const WeeklyTeamSummary = ({ overview }) => {
    const metrics = overview?.metrics || {};
    const compliance = Number(metrics.compliancePercentage || 0);

    return (
        <section className="surface-card border-round p-3 shadow-1" aria-labelledby="ventas-weekly-summary-title">
            <div className="flex flex-column md:flex-row md:align-items-center md:justify-content-between gap-2 mb-3">
                <div>
                    <h3 id="ventas-weekly-summary-title" className="mt-0 mb-1">Resumen semanal del equipo</h3>
                    <p className="text-color-secondary m-0">Las visitas inesperadas se muestran aparte y no aumentan el cumplimiento planificado.</p>
                </div>
                <Tag value={`Actualizado · ${overview?.timezone || 'America/Panama'}`} severity="secondary" />
            </div>

            <div className="ventas-overview-metrics">
                {METRICS.map((metric) => (
                    <div key={metric.key} className="ventas-overview-metric">
                        <i className={metric.icon} aria-hidden="true" />
                        <span>{metric.label}</span>
                        <strong>{Number(metrics[metric.key] || 0)}</strong>
                    </div>
                ))}
                <div className="ventas-overview-metric ventas-overview-metric--compliance">
                    <i className="pi pi-chart-line" aria-hidden="true" />
                    <span>Cumplimiento</span>
                    <strong>{compliance}%</strong>
                    <small>{Number(metrics.plannedCompletedDue || 0)} de {Number(metrics.plannedDue || 0)} visitas que debían realizarse</small>
                    <ProgressBar value={Math.min(100, compliance)} showValue={false} />
                </div>
                <div className="ventas-overview-metric">
                    <i className="pi pi-clock" aria-hidden="true" />
                    <span>Tiempo real de oficina</span>
                    <strong>{Math.round(Number(metrics.officeMinutes || 0) / 6) / 10} h</strong>
                </div>
            </div>

            <div className="ventas-agent-summary-list mt-4">
                {(overview?.byAgent || []).map((item) => {
                    const status = agendaStatus(item.agenda);
                    return (
                        <div key={item.agent?._id} className="ventas-agent-summary-row">
                            <div className="ventas-agent-summary-name">
                                <strong>{item.agent?.name || item.agent?.email || 'Vendedor'}</strong>
                                <Tag value={status.label} severity={status.severity} />
                            </div>
                            <span><b>{item.metrics?.planned || 0}</b> planificadas</span>
                            <span><b>{item.metrics?.completed || 0}</b> completadas</span>
                            <span><b>{item.metrics?.unplanned || 0}</b> inesperadas</span>
                            <span><b>{item.metrics?.pendingReports || 0}</b> reportes pendientes</span>
                            <span><b>{Math.round(Number(item.metrics?.officeMinutes || 0) / 6) / 10}</b> h oficina</span>
                            <strong className="ventas-agent-compliance">{item.metrics?.compliancePercentage || 0}%</strong>
                        </div>
                    );
                })}
                {!overview?.byAgent?.length ? (
                    <div className="ventas-empty-state">
                        <i className="pi pi-users" aria-hidden="true" />
                        <span>No hay vendedores para resumir en esta semana.</span>
                    </div>
                ) : null}
            </div>
        </section>
    );
};

export default WeeklyTeamSummary;
